import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axiosInstance";

const FAQAdmin = () => {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);

  const loadFaqs = async () => {
    const res = await api.get("/api/faqs");
    setFaqs(res.data.data);
  };

  useEffect(() => {
    loadFaqs();
  }, []);

  const remove = async (id) => {
    if (!confirm("Delete this FAQ?")) return;
    await api.delete(`/api/faqs/${id}`);
    loadFaqs();
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">FAQs</h1>
        <button
          onClick={() => navigate("/admin/faqs/new")}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          + New FAQ
        </button>
      </div>

      <div className="space-y-4">
        {faqs.map((faq) => (
          <div
            key={faq._id}
            className="border p-4 rounded flex justify-between"
          >
            <div>
              <p className="font-semibold">{faq.question}</p>
              <p className="text-sm text-gray-600">{faq.category}</p>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() =>
                  navigate(`/admin/faqs/edit/${faq._id}`)
                }
                className="text-blue-600"
              >
                Edit
              </button>
              <button
                onClick={() => remove(faq._id)}
                className="text-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQAdmin;
